<script>
import request from './setup'

class Error {
  constructor() {
    this.response = {}
    this.request = {}
    this.message = {}
  }
}

export default {
  props: {
    method: { type: String, default: 'post' },
    url: { type: String, required: true },
    headers: { type: Object, default: () => {} },
  },
  data() {
    return {
      sending: false,
      response: null,
      error: new Error(),
    }
  },
  methods: {
    send(data) {
      const _this = this
      this.sending = true
      this.response = null,
      this.error = new Error(),
      request[this.method](this.url, data, {
        headers: _this.headers,
      })
        .then((response) => {
          _this.response = response
          _this.$emit('success', response)
        })
        .catch((error) => {
          if (error.response) {
            _this.error.response = error.response
          } else if (error.request) {
            _this.error.request = error.request
          } else {
            _this.error.message = error.message
          }
        })
        .finally(() => {
          _this.sending = false
        })
    },
  },
  render() {
    return this.$scopedSlots.default({
      sending: this.sending,
      response: this.response,
      error: this.error,

      send: this.send,
    })
  },
}
</script>